import { Link } from "react-router-dom";
import { ArrowLeft, Download, Mail, CheckCircle } from "lucide-react";

export function GenderEquality() {
    const certUrl = "/documenti/certiSI.webp";

    return (
        <div className="container py-12 md:py-16">
            <Link to="/" className="inline-flex items-center text-text-body hover:text-brand-primary mb-8 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla Home
            </Link>
            
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title mb-8">Certificazione sulla Parità di Genere</h1>
                
                <div className="prose prose-lg text-text-body max-w-none mb-10">
                    <h2 className="text-2xl font-bold text-text-title mb-4">Che cos'è e a che cosa serve?</h2>
                    
                    <p className="mb-6">
                        La certificazione sulla parità di genere è un riconoscimento formale che attesta l'impegno di un'organizzazione (azienda, ente pubblico, associazione, ecc.) nel promuovere e garantire la parità di genere al suo interno. Questa certificazione non è un obbligo di legge, ma un'adesione volontaria a standard specifici che mirano a eliminare le discriminazioni e a creare un ambiente di lavoro più inclusivo ed equo.
                    </p>

                    <h2 className="text-2xl font-bold text-text-title mb-6">Cosa Certifica:</h2>
                    
                    <div className="grid gap-6 md:grid-cols-2 mb-8">
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Politiche e pratiche</h3>
                            <p>La certificazione valuta l'esistenza e l'efficacia di politiche, procedure e pratiche aziendali che promuovono la parità di genere in diversi ambiti.</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Equità retributiva</h3>
                            <p>Verifica che uomini e donne, a parità di ruolo e responsabilità, ricevano la stessa retribuzione.</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Opportunità di carriera</h3>
                            <p>Esamina se esistono pari opportunità di crescita professionale per entrambi i generi, sia in termini di avanzamento di carriera che di formazione.</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Conciliazione vita-lavoro</h3>
                            <p>Valuta la presenza di misure che facilitino la conciliazione tra la vita professionale e quella personale (es. smart working, flessibilità oraria, asili nido aziendali).</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Prevenzione delle discriminazioni</h3>
                            <p>Accerta l'adozione di misure efficaci per prevenire e contrastare molestie, discriminazioni e ogni forma di violenza di genere.</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <h3 className="text-xl font-bold text-brand-primary mb-3">Cultura aziendale e Rappresentanza</h3>
                            <p>Verifica se l'organizzazione promuove una cultura inclusiva e analizza la presenza di donne in posizioni di leadership e nei ruoli decisionali.</p>
                        </div>
                    </div>

                    <div className="bg-blue-50 p-6 rounded-xl mb-8">
                        <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center">
                            <CheckCircle className="h-6 w-6 mr-2" />
                            Visualizza la nostra certificazione
                        </h3>
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                                <a 
                                    href={certUrl} 
                                    download 
                                    className="inline-flex items-center px-6 py-3 bg-brand-primary text-white font-medium rounded-lg hover:bg-brand-secondary transition-colors shadow-md"
                                >
                                    <Download className="h-5 w-5 mr-2" />
                                    Scarica Certificato
                                </a>
                            </div>
                            
                            <div className="mt-4 border border-gray-200 rounded-lg overflow-hidden shadow-md bg-white p-2">
                                <img 
                                    src={certUrl} 
                                    alt="Certificato Parità di Genere UNI PdR 125:2022" 
                                    className="w-full h-auto object-contain max-h-[600px]"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <Mail className="h-5 w-5 text-brand-primary mr-3" />
                        <div>
                            <span className="font-semibold text-text-title">Contatto email: </span>
                            <a href="mailto:comitatopdr@puglialifesrl.it" className="text-brand-primary hover:underline">
                                comitatopdr@puglialifesrl.it
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
